import type { PromptModelConfigCreate } from '~/redux/api/types/sylvanus/dde';

type ServerDdeModel = {
  datetime_created: string;
  datetime_updated: string;
  id: string;
  model_name: string;
  source_prompt_model_id?: string | null;
  table_id: string;
  user_id: string;
};

export type ServerDdeModelVersion = {
  configuration: Record<string, unknown>;
  datetime_created: string;
  dde_model_id: string;
  prompt_model_id?: string;
  user_email: string;
  user_id: string;
  version_number: number;
};

export type ServerDdeModelCreateResult = {
  model: ServerDdeModel;
  version: ServerDdeModelVersion;
};

export type ServerDdeModelCreateRequest = {
  configuration?: PromptModelConfigCreate | null;
  model_name: string;
  prompt_model_id?: string | null;
};

export type ServerDdeModelVersionCreateRequest = {
  configuration: PromptModelConfigCreate;
};

export type DdeModel = {
  configuration?: Record<string, unknown>;
  datetimeCreated: string;
  datetimeUpdated: string;
  id: string;
  modelName: string;
  sourcePromptModelId?: string | null;
  tableId: string;
  userId: string;
};

export type DdeModelVersion = {
  configuration: Record<string, unknown>;
  datetimeCreated: string;
  ddeModelId: string;
  promptModelId?: string;
  userEmail: string;
  userId: string;
  versionNumber: number;
};

export type DdeModelCreateResult = {
  model: DdeModel;
  version: DdeModelVersion;
};

export type LooseServerDdeModel = {
  configuration?: Record<string, unknown>;
  datetime_created?: string;
  datetime_updated?: string;
  dde_model_id?: string;
  id?: string;
  model_name?: string;
  name?: string;
  prompt_model_id?: string | null;
  source_prompt_model_id?: string | null;
  table_id?: string;
  user_id?: string;
};

const normalizeServerDdeModel = (
  model: LooseServerDdeModel,
): ServerDdeModel => ({
  datetime_created: model.datetime_created ?? '',
  datetime_updated: model.datetime_updated ?? '',
  id: model.dde_model_id ?? model.id ?? '',
  model_name: model.model_name ?? model.name ?? '',
  source_prompt_model_id:
    model.source_prompt_model_id ?? model.prompt_model_id ?? null,
  table_id: model.table_id ?? '',
  user_id: model.user_id ?? '',
});

export const mapDdeModel = (model: LooseServerDdeModel): DdeModel => {
  const normalized = normalizeServerDdeModel(model);

  return {
    configuration: model.configuration,
    datetimeCreated: normalized.datetime_created,
    datetimeUpdated: normalized.datetime_updated,
    id: normalized.id,
    modelName: normalized.model_name,
    sourcePromptModelId: normalized.source_prompt_model_id,
    tableId: normalized.table_id,
    userId: normalized.user_id,
  };
};

export const mapDdeModelVersion = (
  version: ServerDdeModelVersion,
): DdeModelVersion => ({
  configuration: version.configuration,
  datetimeCreated: version.datetime_created,
  ddeModelId: version.dde_model_id,
  promptModelId: version.prompt_model_id,
  userEmail: version.user_email,
  userId: version.user_id,
  versionNumber: version.version_number,
});

export const mapDdeModelCreateResult = (
  response: ServerDdeModelCreateResult,
): DdeModelCreateResult => ({
  model: mapDdeModel(response.model),
  version: mapDdeModelVersion(response.version),
});
